import { TypeCompService } from '../../../shared/services/simple/type-comp.service';
import { CgChargeService } from 'src/app/shared/services/simple/cg-charge.service';
import { ModalAddNaComponent } from '../../../shared/components/modals/modal-add-na/modal-add-na.component';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { TypeCompModel } from '../../../shared/models/simple-types/type-comp.model';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { NaService } from 'src/app/shared/services/simple/na.service';

@Component({
  selector: 'app-gestion-na',
  templateUrl: './gestion-na.component.html',
  styleUrls: ['./gestion-na.component.scss']
})
export class GestionNaComponent implements OnInit {

  nas: NaModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'analyt2', 'cgCharge', 'typeComp' , 'action'];
  dataSource: NaModel[];
  matDataSource = new MatTableDataSource<NaModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  objet: SimpleQueryUser = new SimpleQueryUser();
  pageEvent: PageEvent;
  idSociete: number;
  result: boolean;
  typeComps: TypeCompModel[] = [];
  cgCharges: CgChargeModel[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private naService: NaService,
    private cgChargeService: CgChargeService,
    private typeCompService: TypeCompService,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService) { }

  ngOnInit(): void {
      this.objet.query = '';
      this.objet.pageNumber = 0;
      this.objet.pageSize = this.pageSize;
      this.objet.order = 'libelle';
      this.matDataSource.paginator = this.paginator;
      this.loadPage();
      // getAll cgCharge societe 1
      this.cgChargeService.getAll().subscribe(cgs => {
        this.cgCharges = cgs;
      });
      // getAll typeComp
      this.typeCompService.getAll().subscribe(types => {
        this.typeComps = types;
      });
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateNaFormGroup();
    const dialogRef = this.dialog.open(ModalAddNaComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          nas: this.nas,
          cgCharges: this.cgCharges,
          typeComps: this.typeComps,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.naService.getAll().subscribe((nas: NaModel[]) => {
            this.dataSource = nas;
            this.loadPage();
          });
        }
      });

  }

  onModify(na: NaModel): void {
    const form = this.gestionReferentielComponent.getEditNaFormGroup(na);
    const dialogRef = this.dialog.open(ModalAddNaComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.idSociete,
          form,
          cgCharges: this.cgCharges,
          typeComps: this.typeComps,
          nas: this.nas,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      this.onUpdated.emit(true);
      if (result) {
        this.loadPage();
      }
    });
  }


  onDelete(na: NaModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression de la nature analytique',
        message: 'Êtes-vous sur de vouloir supprimer la nature analytique ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.naService.delete(na.id).subscribe((response: NaModel) => {
          this.toastrService.success('La nature analytique a bien été supprimée');
          this.loadPage();
        });
      }
    });
  }

  getTypeCompByCode(code: string): string{
    const type = this.typeComps.find(typeC => typeC.code === code);
    if (type) {
      return type.code + '-' + type.libelle;
    } else {
      return '';
    }
  }

  getCgByCode(code: string): string{
    const cgCarge = this.cgCharges.find(cg => cg.code === code);
    if (cgCarge) {
      return cgCarge.code + '-' + cgCarge.libelle;
    } else {
      return '';
    }
  }

  orderUsers(nas: NaModel[]): NaModel[] {
    nas = nas.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return nas;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.idSociete;
    this.naService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<NaModel>) => {
      if (query.objets != null) {
        this.nas = query.objets;
      } else {
        this.nas = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<NaModel>(this.nas);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}

